import React from "react";

interface IDualEmploymentComponentProps { }

export const DualEmploymentComponent: React.FC<
    IDualEmploymentComponentProps
> = () => {
    const datas = [
        {
            title: "Dual employment",
            description:
                "When an individual holds two full-time jobs simultaneously it can lead to productivity loss, confidentiality risks, and legal non-compliance. Our Dual Employment Check service helps organizations identify overlapping employment records, ensuring workforce integrity and adherence to company policies.",
            icon: "/assets/dual-employment/dual-employment.webp",
        },
        {
            title: "What We Verify?",
            description: (
                <ul>
                    <li data-aos="fade-up" data-aos-delay="100">
                        Cross-verification of employment history from multiple
                        sources
                    </li>
                    <li data-aos="fade-up" data-aos-delay="200">
                        Active employment status with other organizations
                    </li>
                    <li data-aos="fade-up" data-aos-delay="300">
                        Identification of overlapping tenures
                    </li>
                </ul>
            ),
            icon: "/assets/dual-employment/what-we-verify.webp",
        },
        {
            title: "Who Needs This?",
            description: (
                <ul>
                    <li data-aos="fade-up" data-aos-delay="100">
                        Enterprises with large or remote workforces
                    </li>
                    <li data-aos="fade-up" data-aos-delay="200">
                        Companies offering flexible work models (e.g., WFH,
                        freelance, gig)
                    </li>
                    <li data-aos="fade-up" data-aos-delay="300">
                        HR departments looking to enhance background screening
                        protocols
                    </li>
                </ul>
            ),
            icon: "/assets/dual-employment/who-needs-this.webp",
        },
        {
            title: "Fast. Accurate. Discreet.",
            description: (
                <ul>
                    <li data-aos="fade-up" data-aos-delay="100">
                        Our Dual Employment Checks are performed with strict
                        confidentiality, using secure, tech-enabled platforms
                        and human intelligence to deliver verified insights you
                        can act on.
                    </li>
                </ul>
            ),
            icon: "/assets/dual-employment/fast-accurate-discreet.webp",
        },
    ];

    return (
        <section id="features" className="features section">
            <div className="container">
                <div className="row gy-4">
                    <h4
                        className="mb-4"
                        data-aos="fade-up"
                        data-aos-delay="100"
                    >
                        Detect Conflicts. Protect Your Workforce.
                    </h4>
                    {datas.map((data, index) => {
                        const isEven = index % 2 === 0;

                        return (
                            <div
                                key={index}
                                className="col-lg-12 features-item d-flex ps-0 ps-lg-3 pt-4 pt-lg-0 mb-4"
                                data-aos="fade-up"
                                data-aos-delay={index * 100}
                            >
                                <div className="row gy-4 p-2 align-items-center">
                                    <div
                                        className={`col-md-4 ${isEven ? "order-md-1" : "order-md-2"
                                            }`}
                                    >
                                        <img loading="lazy"
                                            src={data.icon}
                                            className="img-fluid border-radius-10px"
                                            alt={data.title}
                                            data-aos="fade-up"
                                            data-aos-delay={index * 100}
                                        />
                                    </div>
                                    <div
                                        className={`col-md-8 ${isEven ? "order-md-2" : "order-md-1"
                                            }`}
                                    >
                                        <h4>{data.title}</h4>
                                        <p>{data.description}</p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
